"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var trans_1 = __importDefault(require("@/plugins/trans"));
var ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
var SearchVacancy_1 = __importDefault(require("./SearchVacancy"));
var SearchLocation_1 = __importDefault(require("./SearchLocation"));
var SearchFilter_1 = __importDefault(require("./SearchFilter"));
var index_1 = require("../icons/index");
var GraduationCapIcon_1 = __importDefault(require("../icons/GraduationCapIcon"));
var CrosshairIcon_1 = __importDefault(require("../icons/CrosshairIcon"));
var ClockIcon_1 = __importDefault(require("../icons/ClockIcon"));
var StickyContext_1 = __importDefault(require("../context/StickyContext"));
var useIsSmallScreen_1 = __importDefault(require("../hooks/useIsSmallScreen"));
var SearchBarStyles_1 = require("./SearchBarStyles");
var hourProps = {
    queryKey: 'availability',
    options: [
        { value: 1, display: '0-8 uur' },
        { value: 2, display: '8-16 uur' },
        { value: 3, display: '16-24 uur' },
        { value: 4, display: '24-32 uur' },
        { value: 5, display: '32-40 uur' },
    ],
};
var educationProps = {
    queryKey: 'educationalLevels',
    options: [
        { value: 1, display: 'LBO' },
        { value: 2, display: 'MBO' },
        { value: 3, display: 'HBO' },
        { value: 4, display: 'Universitair' },
    ],
};
var radiusProps = {
    queryKey: 'distance',
    options: [
        { value: 5, display: '5KM' },
        { value: 10, display: '10KM' },
        { value: 25, display: '25KM' },
        { value: 50, display: '50KM' },
        { value: 100, display: '> 100KM' },
    ],
};
var SearchBarView = function (_a) {
    var handleSearchChange = _a.handleSearchChange, handleSearchClick = _a.handleSearchClick;
    var _b = (0, react_1.useState)(false), expanded = _b[0], setExpanded = _b[1];
    var searchBarRef = (0, react_1.useRef)(null);
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    var instantSearch = pathname.includes('/vacancies');
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var isStickySearchBar = (0, react_1.useContext)(StickyContext_1.default).isStickySearchBar;
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, direction: "column", spacing: 2, sx: SearchBarStyles_1.searchBarContainerStyles.container }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, item: true, spacing: 2, justifyContent: "center", sx: {
                    alignItems: 'flex-end',
                    paddingTop: '24px',
                    paddingBottom: 4,
                    '& p': {
                        fontWeight: 'bold',
                    },
                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ ref: searchBarRef, item: true, xs: 12, md: 3, sx: SearchBarStyles_1.searchBarContainerStyles.marginLeftRight }, { children: (0, jsx_runtime_1.jsx)(SearchVacancy_1.default, { handleSearchChange: handleSearchChange }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, md: 3, sx: SearchBarStyles_1.searchBarContainerStyles.marginLeftRight }, { children: (0, jsx_runtime_1.jsx)(SearchLocation_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, md: 3, sx: SearchBarStyles_1.searchBarContainerStyles.marginLeftRight }, { children: (0, jsx_runtime_1.jsxs)(material_1.Button, __assign({ onClick: function () { return handleSearchClick(); }, fullWidth: isSmallScreen, sx: __assign(__assign({}, SearchBarStyles_1.searchBarContainerStyles.searchButton), { marginTop: isSmallScreen ? 4 : 0 }) }, { children: [trans_1.default.get('buttons.frontend.vacancy.search'), " ", (0, jsx_runtime_1.jsx)(index_1.ArrowRightIcon, { sx: { marginLeft: '8px', stroke: '#FF4F6B' } })] })) }))] })), (0, jsx_runtime_1.jsxs)(material_1.Collapse, __assign({ in: !isStickySearchBar }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Accordion, __assign({ expanded: expanded, onChange: function () { return setExpanded(!expanded); }, disableGutters: true, sx: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                            color: 'white',
                            ':before': {
                                backgroundColor: 'transparent',
                            },
                        } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.AccordionSummary, __assign({ id: "additionalFilters", "aria-controls": "additionalFiltersContent", sx: {
                                    '& .MuiAccordionSummary-content': {
                                        marginTop: '-12px',
                                        justifyContent: 'center',
                                    },
                                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { children: expanded ? 'Minder filters' : 'Meer filters' }), (0, jsx_runtime_1.jsx)(ExpandMore_1.default, { sx: {
                                            transform: expanded ? 'rotate(180deg)' : '',
                                            transition: 'transform 150ms ease',
                                        } })] })), (0, jsx_runtime_1.jsx)(material_1.AccordionDetails, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, item: true, spacing: 2, justifyContent: "center", sx: {
                                        '& p': {
                                            fontWeight: 'bold',
                                        },
                                    } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, md: 2, xs: 12, sx: SearchBarStyles_1.searchBarContainerStyles.facets }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2" }, { children: trans_1.default.get('labels.frontend.search.filter.hour') })), (0, jsx_runtime_1.jsx)(SearchFilter_1.default, __assign({}, hourProps, { icon: (0, jsx_runtime_1.jsx)(ClockIcon_1.default, {}), multiple: true }))] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, md: 2, xs: 12, sx: SearchBarStyles_1.searchBarContainerStyles.facets }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2" }, { children: trans_1.default.get('labels.frontend.search.filter.education') })), (0, jsx_runtime_1.jsx)(SearchFilter_1.default, __assign({}, educationProps, { icon: (0, jsx_runtime_1.jsx)(GraduationCapIcon_1.default, {}), multiple: true }))] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, md: 2, xs: 12, sx: SearchBarStyles_1.searchBarContainerStyles.facets }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2" }, { children: trans_1.default.get('labels.frontend.search.filter.radius') })), (0, jsx_runtime_1.jsx)(SearchFilter_1.default, __assign({}, radiusProps, { icon: (0, jsx_runtime_1.jsx)(CrosshairIcon_1.default, {}) }))] }))] })) })] })), instantSearch && ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, justifyContent: "center", xs: 12, sx: SearchBarStyles_1.searchBarContainerStyles.blackBar }, { children: [(0, jsx_runtime_1.jsx)(index_1.RFIcon, { fontSize: "large" }), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: SearchBarStyles_1.searchBarContainerStyles.blackBarText }, { children: trans_1.default.get('strings.frontend.vacancy.searchBar_motivate') })), (0, jsx_runtime_1.jsx)(index_1.RFIcon, { fontSize: "large" })] })))] }))] })));
};
exports.default = SearchBarView;
